import Api, { baseURL } from '../Api'

const BASE = `${baseURL('v2')}/{departamento}/indicadores/produtividade`

export default {
  async gerais(params) {
    return Api.get(`${BASE}/gerais`, params)
  },
  async resumos(params) {
    return Api.get(`${BASE}/resumos`, params)
  },
}
